<template>
    <numbering-check-settings
        model-name="selfinvoice"
        document-label="le autofatture"
    />
</template>

<script>
import NumberingCheckSettings from '@/components/common/NumberingCheckSettings'

export default {
    name: 'selfinvoices-other',
    components: {
        NumberingCheckSettings
    }
}
</script>
